
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-me",
      function () {
        return require("private-next-pages/contact-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-me"])
      });
    }
  